var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { deviceDimensions } from '@showroomjs/core';
import { GalaxyNote10, IPad, IPadMini, IPadPro, IPhone8, IPhoneX, MacbookAir, MacbookPro, } from '@showroomjs/device-frames';
import '@showroomjs/device-frames/dist/index.css';
import * as React from 'react';
export const DeviceFrame = (_a) => {
    var { dimension, showFrame } = _a, props = __rest(_a, ["dimension", "showFrame"]);
    if (!showFrame) {
        return React.createElement(React.Fragment, null, props.children);
    }
    const d = dimension;
    const matchedDevice = deviceDimensions.find((device) => device.height === d.height && device.width === d.width);
    if (matchedDevice) {
        switch (matchedDevice.name) {
            case 'iPhone 6/7/8':
                return React.createElement(IPhone8, Object.assign({}, props));
            case 'iPhone X':
                return React.createElement(IPhoneX, Object.assign({}, props));
            case 'iPad':
                return React.createElement(IPad, Object.assign({}, props));
            case 'iPad Mini':
                return React.createElement(IPadMini, Object.assign({}, props));
            case 'iPad Pro':
                return React.createElement(IPadPro, Object.assign({}, props));
            case 'Macbook Air':
                return React.createElement(MacbookAir, Object.assign({}, props));
            case 'Macbook Pro':
                return React.createElement(MacbookPro, Object.assign({}, props));
            case 'Galaxy Note 10':
                return React.createElement(GalaxyNote10, Object.assign({}, props));
        }
    }
    return (React.createElement("div", { style: {
            width: d.width,
            height: d.height,
        } }, props.children));
};
//# sourceMappingURL=device-frame.js.map